import { api, APIResponse } from '@/store/api';
import type { UserStatistics } from '@/types/dashboard.types';

export const dashboardApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserStatistics: builder.query<UserStatistics, void>({
      query: () => 'admin/users/statistics',
      transformResponse: (response: APIResponse<UserStatistics>) => response.data,
      providesTags: ['Dashboard'],
    }),
  }),
});

export const { useGetUserStatisticsQuery } = dashboardApi; 